import axios from '@/services/mediligo-axios'

const login  = {
  getUrl: (email, next) => axios.get(`/api/login/url?email=${email}&next=${next}`),
}

const account  = {
  logout: () => axios.get(`/api/account/logout`),
  getProfile: () => axios.get(`/api/account/profile`),
  updateProfile: (data) => axios.put(`/api/account/profile`, data),
  connectVimeo:() => axios.get(`/api/account/profile/connectvimeo`)
}

const consent  = {
  get: () => axios.get(`/api/consent`),
  getForLabel: (consentLabel) => axios.get(`/api/consent/${consentLabel}`),
  getConsentHistory: (consentId) => axios.get(`/api/consent/${consentId}/history`),
  getPage: (language) => axios.get(`/api/consent/page?language=${language}`),
  getPageForLabel: (consentLabel, language) => axios.get(`/api/consent/page/${consentLabel}?language=${language}`),
  handleConsent: (data) => axios.put(`/api/consent`, data),
  handleConsentForLabel: (consentLabel, data) => axios.put(`/api/consent/${consentLabel}`, data),
}

const newsItems = {
  getList: (type, lang) => axios.get(`/api/newsitem/list?type=${type}&lang=${lang}`),
  getItem: (id) => axios.get(`/api/newsitem/newsitem?id=${id}`),
  getSas: (mediaId) => axios.get(`/api/newsitem/sas/${mediaId}`)
}

const watch = {
  getCollections: () => axios.get(`/api/watch/collections`),
  getCollection: (id) => axios.get(`/api/watch/collections/${id}`),
  getCategories: () => axios.get(`/api/watch/categories`),
  getCategoryDetails: (id) => axios.get(`/api/watch/category/details/${id}`),
  getSeries: (id) => axios.get(`/api/watch/category/${id}`),
  getMovies: (id) => axios.get(`/api/watch/movies/${id}`),
  getMovie: (id) => axios.get(`/api/watch/player/${id}`),
  getMovieDetails: (id) => axios.get(`/api/watch/movie/details/${id}`),
  getLatest: () => axios.get(`/api/watch/latest`),
  getLatestVimeo: () => axios.get(`/api/watch/latestvimeo`),
  getAsset: (id, system) => axios.get(`/api/watch/asset?id=${id}&system=${system}`),
}

const connections  = {
  getWatchOnTheGo: () => axios.get(`/api/connection/watch-on-the-go`),
  getWefitterStatus: () => axios.get(`/api/connection/wefitter/status`),
  getWefitterConnections: () => axios.get(`/api/connection/wefitter/connections`),
  deleteConnection: (connection) => axios.delete(`/api/connection/wefitter/connections/${connection}`),
  getWefitterBioAgeList: (start, end) => axios.get(`/api/connection/wefitter/bio-age/list?start=${start}&end=${end}`),
  activateBioAge: () => axios.put(`/api/connection/wefitter/bio-age/connect`),
  getWefitterDailySummary: (start, end) => axios.get(`/api/connection/wefitter/daily-summary?start=${start}&end=${end}`),
  getWefitterDailyDetails: (start, end) => axios.get(`/api/connection/wefitter/daily-details?start=${start}&end=${end}`),
  deleteWefitterProfile: () => axios.delete(`/api/connection/wefitter/profile`),
  createWefitterProfile: () => axios.get(`/api/connection/wefitter/profile/create`),
  getWefitterProfile: () => axios.get(`/api/connection/wefitter/profile`),
}

const eventLogs  = {
  postEvent: (data) => axios.post(`/api/event`, data),
}

const structures = {
  getStructureById: (id) => axios.get(`/api/structure?id=${id}`),
  getStructureChildrenById: (id) => axios.get(`/api/structure/children?id=${id}`),
  getStructureMenuByLanguage: (lang) => axios.get(`/api/structure/menu?lang=${lang}`),
  getLatestStructuresFromVimeo: (id) => axios.post(`/api/structure/latestfromvimeo`, id),
  getSasByMediaId: (mediaId) => axios.get(`/api/structure/sas/${mediaId}`),
}

const contentStructures = {
  getStructureMenuGeneral: () => axios.get(`/api/structure/menu/general`),
  getStructureById: (id) => axios.get(`/api/structure/${id}`),
  getStructureChildrenById: (id) => axios.get(`/api/structure/children/${id}`),
  getStructureSpotlight: () => axios.get(`/api/structure/spotlight`),
}

const challenges = {
  getList: () => axios.get(`/api/challenge/list`),
  getChallenge: (id) => axios.get(`/api/challenge/${id}`),
}

const userRegistrations = {
  getRegistrationExists: (registrationModuleId) => axios.get(`/api/user/registration/exists/${registrationModuleId}`),
  getRegistration: (registrationModuleId) => axios.get(`/api/user/registration/registration/${registrationModuleId}`),
  getRegistrationCount: (registrationModuleId) => axios.get(`/api/user/registration/count/${registrationModuleId}`),
  postRegistrationRegister: (registrationModuleId) => axios.post(`/api/user/registration/register/${registrationModuleId}`),
  deleteRegistration: (registrationId) => axios.delete(`/api/user/registration/register/${registrationId}`)
}

const unbox = {
  getData: () => axios.get(`/api/unbox/data`),
  getSas: (mediaId) => axios.get(`/api/unbox/sas/${mediaId}`)
}

const media = {
  getOrganizationlogosSas: (mediaId) => axios.get(`/api/media/organizationlogos/sas/${mediaId}`)
}

const weFitter = {
  getWefitterData: (model)=> axios.post(`/api/wefitter/data`, model)
}
export default {
  login,
  account,
  consent,
  newsItems,
  watch,
  connections,
  eventLogs,
  structures,
  userRegistrations,
  unbox,
  media,
  weFitter,
  contentStructures,
  challenges
}
